// import React from 'react';
// import PropTypes from 'prop-types';
// import CloseButton from '../../common/CloseButton/CloseButton';
// import '../../common/CommonText.css';
// import LargeDetailTextBox from '../../common/DetailBox/LargeDetailTextBox';
// import LargeDetailBox from '../../common/DetailBox/LargeDetailBox';
// import SmallDetailBox from '../../common/DetailBox/SmallDetailBox';

// const InternalUserDetailPopup = ({ isOpen, title, details, tableHeaders, tableRows, onClose }) => {
//     if (!isOpen) return null;
  
//     return (
//       <div className="popup-overlay">
//         <div className="popup popup1 internal-user-popup">
//           <CloseButton onClick={onClose} />
//           <div className="popup-name-button">
//             <h2 className="popup-name">{title}</h2>
//           </div>
//           <div className="edit-second-input-box-container detail-popup-container">
//           {details.map((detail, index) => {
//             if (detail.type === 'large') {
//               return <LargeDetailBox key={index} label={detail.label} value={detail.value} />;
//             } else if (detail.type === 'small') {
//               return <SmallDetailBox key={index} label={detail.label} value={detail.value} />;
//             } else {
//               return (
//                 <div key={index} className="input-box-container">
//                   <label className="input-label has-value">{detail.label}</label>
//                   <input
//                     type="text"
//                     className="input-box detail-box"
//                     value={detail.value}
//                     readOnly
//                   />
//                 </div>
//               );
//             }
//           })}
//         </div>
// \
//           {tableHeaders && tableHeaders.length > 0 && tableRows && tableRows.length > 0 && (
//             <div className="internal-user-table-container">
//             <div className="internal-user-table-scrollable">
//               <table className="internal-user-table">
//                 <thead className="common-table-head internal-user-table-thead">
//                   <tr className="common-table-thead-tr internal-user-role-tr">
//                     {tableHeaders.map((header, index) => (
//                       <th key={index}>{header}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody className="internal-user-table-tbody">
//                   {tableRows.map((row, rowIndex) => (
//                     <tr key={rowIndex} className="internal-user-table-tbody-tr">
//                       {row.map((cell, colIndex) => (
//                         <td key={colIndex}>
//                           {colIndex === 0 ? (
//                             <span className="common-text fts-15 dk-gray ftw-4">{cell}</span>
//                           ) : (
//                             <input
//                               className="table-selectbox internal-user-table-checkbox"
//                               type="checkbox"
//                               checked={cell}
//                               readOnly
//                             />
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };
  
//   InternalUserDetailPopup.propTypes = {
//     isOpen: PropTypes.bool.isRequired,
//     title: PropTypes.string.isRequired,
//     details: PropTypes.arrayOf(PropTypes.shape({
//       label: PropTypes.string.isRequired,
//       value: PropTypes.string.isRequired,
//     })).isRequired,
//     tableHeaders: PropTypes.arrayOf(PropTypes.string),
//     tableRows: PropTypes.arrayOf(PropTypes.array),
//     onClose: PropTypes.func.isRequired,
//   };
  
//   export default InternalUserDetailPopup;

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css';
import LargeDetailTextBox from '../../common/DetailBox/LargeDetailTextBox';
import LargeDetailBox from '../../common/DetailBox/LargeDetailBox';
import SmallDetailBox from '../../common/DetailBox/SmallDetailBox';

const InternalUserDetailPopup = ({ isOpen, title, details, tableHeaders, tableRows, onClose ,selected}) => {
  const [formValues, setFormValues] = useState(selected);

  useEffect(() => {
    setFormValues(selected); 
  }, [selected]);
  
  
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup popup1 internal-user-popup">
        <CloseButton onClick={onClose} />
        <div className="popup-name-button">
          <h2 className="popup-name">{title}</h2>
        </div>
        <div className="edit-second-input-box-container detail-popup-container">
          {details.map((detail, index) => {
            if (detail.type === 'large') {
              return <LargeDetailBox key={index} label={detail.label} value={detail.value} />;
            } else if (detail.type === 'small') {
              return <SmallDetailBox key={index} label={detail.label} value={detail.value} />;
            } else {
              return (
                <div key={index} className="input-box-container">
                  <label className="input-label has-value">{detail.label}</label>
                  <input
                    type="text"
                    className="input-box detail-box"
                    value={detail.value}
                    readOnly
                  />
                </div>
              );
            }
          })}
        </div>

        {tableHeaders && tableHeaders.length > 0 && tableRows && tableRows.length > 0 &&  formValues && (
          <div className="internal-user-table-container">
            <div className="internal-user-table-scrollable">
              <table className="internal-user-table">
                <thead className="common-table-head internal-user-table-thead">
                  <tr className="common-table-thead-tr internal-user-role-tr">
                    <th className="text-left">Permission</th>
                    <th className="text-center">View</th>
                    <th className="text-center">View All</th>
                    <th className="text-center">Add</th>
                    <th className="text-center">Edit</th>
                    <th className="text-center">Archive</th>
                    <th className="text-center">Delete</th>
                  </tr>
                </thead>
                {/* <tbody className="internal-user-table-tbody">
                    {tableRows.map((row, rowIndex) => (
                        <tr key={rowIndex} className="internal-user-table-tbody-tr">
                          <td>{row.feature_name}</td>
                          
                          {['view','view_all' ,'add', 'edit', 'archive', 'delete'].map((accessName, colIndex) => {
                            const permission = row.permissions.find(perm => perm.access_name === accessName);
                            
                            return (
                              <td key={colIndex} className="text-center">
                                {permission ? (
                                  <input
                                    className="table-selectbox internal-user-table-checkbox"
                                    type="checkbox"
                                    checked={formValues.permissions?.some(perm => perm.id === permission.id) || false}
                                    readOnly
                                  />
                                ) : (
                                  <span>&nbsp;</span>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                    ))}
                    </tbody> */}
<tbody className="internal-user-table-tbody">
{tableRows
  .filter(row =>
    row.permissions.some(p =>
      formValues.permissions?.some(fp => fp.id === p.id)
    )
  )
  .map((row, rowIndex) => (
    <tr key={rowIndex} className="internal-user-table-tbody-tr">
      <td>{row.feature_name}</td>
      {['view', 'view_all', 'add', 'edit', 'archive', 'delete'].map((accessName, colIndex) => {
        const permission = row.permissions.find(perm => perm.access_name === accessName);
        const isAssigned = permission && formValues.permissions?.some(p => p.id === permission.id);

        return (
          <td key={colIndex} className="text-center">
            {isAssigned ? (
              <input
                className="table-selectbox internal-user-table-checkbox"
                type="checkbox"
                checked={true}
                readOnly
              />
            ) : null}
          </td>
        );
      })}
    </tr>
))}

</tbody>

              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

InternalUserDetailPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  tableHeaders: PropTypes.arrayOf(PropTypes.string),
  tableRows: PropTypes.arrayOf(PropTypes.array),
  onClose: PropTypes.func.isRequired,
};

export default InternalUserDetailPopup;
